<template>
  <div class="home">
    <NotFound v-if="fetched && page404" :data="data"></NotFound>
    <AppHeader
      v-if="isShowMenu && restored && !page404"
      :isLogin="isLogin"
      :isMyHome="isMyHome"
      :isEditMode="isEditMode"
      @clickSignup="m = 'signup'"
      @clickResetPassword="m = 'reset-password'"
      @clickSignin="m = 'signin'"
      @clickSignout="logout"
      @clickShare="m = 'share'"
      @clickEdit="openEdit"
      @clickInbox="clickInbox"
      @clickAvatar="clickAvatar"
    ></AppHeader>
    <div v-if="!fetched || !page404" class="home-header"></div>
    <User
      v-if="fetched && data && !page404"
      :data="data"
      :config="config"
      :isNutsbpLogin="isNutsbpLogin"
      :isShowSend="isShowSend"
      :isEditMode="isEditMode"
      :isMyHome="isMyHome"
      @update:user="updateUser"
      @update:me="updateMe"
      @update:module="updateModule"
      @update:m="updateM"
      @update:isNutsbpLogin="v => isNutsbpLogin=v"
    ></User>
    <AppFooter v-if="isShowFooter && fetched && !page404"></AppFooter>

    <SignupModal v-if="m === 'signup'" @close="closeModal" @commit="commitSignup" @signin="m = 'signin'" :error="error"></SignupModal>
    <ResetPasswordModal v-if="m === 'reset-password'" @close="closeModal" @commit="commitResetPassword" @signin="m = 'signin'"></ResetPasswordModal>
    <SigninModal v-if="m === 'signin'" @close="closeModal" @commit="commitSignin" @reset="m = 'reset-password'" @signup="m = 'signup'" :error="error"></SigninModal>
    <QrcodeModal v-if="m === 'qrcode'" @close="closeModal"></QrcodeModal>
    <ConfirmModal
      v-if="m === 'home'"
      :lang="{
        close: '留在原地',
        commit: '前往主页'
      }"
      @close="closeModal"
      @commit="goHome"
    >当前页面不是你的个人主页，请选择是否前往您的个人主页</ConfirmModal>

    <BrowserShareCover v-if="m === 'share' && isMobile && !isWeixinBrowser" @click="m=null"></BrowserShareCover>
    <WeixinShareCover v-if="m === 'share' && isMobile && isWeixinBrowser" @click="m=null"></WeixinShareCover>
    <wx
      v-if="fetched && isWeixinBrowser"
      :debug="debug"
      :title="shareTitle"
      :desc="shareDesc"
      :imgUrl="shareImgUrl"
    ></wx>
  </div>
</template>

<script>
import _ from 'lodash'
import wx from '@/wx.vue'
import env from '@/env.js'
import util from '@/util.js'
import Mem from '@/Mem.js'
import Store from '@/Store.js'
import defaultMdList from './defaultMdList.js'

import {
  conf,
  dcV1,
  dcV2Graphql,
  nutsbpV2,
  ranch
} from '@/api'

import {
  SignupModal,
  ResetPasswordModal,
  SigninModal,
  QrcodeModal,
  ConfirmModal,
  BrowserShareCover,
  WeixinShareCover
} from '@/components'
import {
  User,
  Header as AppHeader,
  Footer as AppFooter,
  NotFound
} from '@/containers'

export default {
  components: {
    wx,
    SignupModal,
    ResetPasswordModal,
    SigninModal,
    QrcodeModal,
    ConfirmModal,
    BrowserShareCover,
    WeixinShareCover,
    User,
    AppHeader,
    AppFooter,
    NotFound
  },
  data () {
    return {
      m: null,
      isLocked: true,
      isLogin: false,
      isNutsbpLogin: false,
      isMyHome: false,
      isEditMode: false,
      restored: false,
      fetched: false,
      error: null, // 共用 response error payload
      data: null,
      defaultMdList,
      config: {
        stage: ['种子', '天使轮', 'Pre-A', 'A轮', 'B轮', 'C轮', 'D轮'].map(row => {
          return {
            label: row,
            value: row
          }
        }),
        industry: []
      }
    }
  },
  computed: {
    debug () {
      return env.debug
    },
    isMobile () {
      return env.isMobile
    },
    isWeixinBrowser () {
      return env.ua.browser.name === 'WeChat'
    },
    pageAccount () {
      return util.pathToUserId(location.pathname)
    },
    pageDomain () {
      return `${this.pageAccount}.dartcome.com`
    },
    page404 () {
      return _.get(this.data, 'pr_state') !== 1
    },
    isShowMenu () {
      return this.$route.query.menu !== 'hide'
    },
    isShowSend () {
      return this.$route.query.send !== 'hide'
    },
    isShowFooter () {
      return this.$route.query.footer !== 'hide'
    },
    shareTitle () {
      let name = _.get(this.data, 'card.name', this.pageAccount)
      return `找${name}投递BP`
    },
    shareDesc () {
      let rList = []
      let title = _.get(this.data, 'card.title')
      if (title) {
        rList.push(`${title}`)
      }
      let labels = []
      labels = _.get(this.data, 'user_module[0].value[0].value', [])
        .map(k => {
          let o = _.find(this.config.industry, {value: k})
          if (o) {
            return o.label
          }
          return null
        })
        .filter(row => row)
      if (labels.length > 0) {
        rList.push(`投资阶段: ${labels.join('/')}`)
      }
      labels = _.get(this.data, 'user_module[0].value[1].value', [])
        .map(k => {
          let o = _.find(this.config.industry, {value: k})
          if (o) {
            return o.label
          }
          return null
        })
        .filter(row => row)
      if (labels.length > 0) {
        rList.push(`关注领域: ${labels.join('/')}`)
      }
      if (rList.length <= 0) {
        return this.pageDomain
      }
      return rList.join(', ')
    },
    shareImgUrl () {
      let url = _.get(this.data, 'card.head_image_url')
      if (url) {
        return url
      }
      return 'http://az.cdn.nutsbp.com/007/image/nuts_dartcome/logo/dartcome_logo_100x100.png'
    }
  },
  methods: {
    updateM (m) { this.m = m },
    closeModal () {
      this.m = null
      this.error = null
    },
    afterLogin (data) {
      Mem.set('me.u', data)

      const token = _.get(data, 'token')
      if (token) {
        Store.set('token', token)
      }
      const sessionId = data['.session_id']
      if (sessionId) {
        Store.set('sid', sessionId)
      }
      const account = _.get(data, 'account')
      if (account) {
        Store.set('account', account)
      }
      const uuid = _.get(data, 'uuid')
      if (uuid) {
        Store.set('uuid', uuid)
        if (uuid === _.get(this.data, 'uuid')) {
          this.isMyHome = true
        }
      }
      this.isLogin = true
      if (this.isMyHome) {
        // this.isEditMode = true
      }
    },
    async restore () {
      try {
        // dartcome
        const token = Store.get('token')
        if (token) {
          let res = await dcV1.get('/me', {
            headers: {
              Authorization: `Token ${token}`
            }
          })
          let data = _.get(res, 'data.data')
          this.afterLogin(data)
        }
        // nutsbp
        const u = Store.get('u')
        if (u) {
          let res = await nutsbpV2.get('/me', {
            headers: {
              Authorization: `nutsbp-token ${u}`,
              'x-nuts-version': `dartcome-pr ${env.version}`,
              'x-nuts-device': '3'
            }
          })
          Mem.set('nutsbp', _.get(res, 'data.data'))
          this.isNutsbpLogin = true
        }
      } catch (e) {
        this.error = _.get(e, 'response.data.msg') || e.message
      } finally {
        this.restored = true
      }
    },
    logout () {
      Store.clear()
      window.location.reload()
    },
    async commitResetPassword (input) {
      try {
        let options = {
          phone: input.phone,
          verify_code: input.code,
          password: input.password
        }
        await dcV1.patch('/password', options)
        this.m = 'signin'
      } catch (e) {
        this.error = _.get(e, 'response.data.msg') || e.message
      }
    },

    async commitSignup (input) {
      let validate = await this.$validator.validateAll(input)

      if (!validate) {
        this.error = this.errors.all()[0]
        return
      }

      let options = {
        password: input.password,
        phone: input.username,
        verify_code: input.code
      }

      try {
        let res = await dcV1.post('/u/register/', options)
        let data = _.get(res, 'data.data')
        /**
         *
  {
    "_id": "5a4d7bd39b8d4008a777ae22",
    "phone": "15750733666",
    "gp": {
      "1": {
        "name": "存档",
        "onworkplace": 0,
        "p": [],
        "order": "1",
        "action": "SAVE"
      },
      "2": {
        "name": "回收站",
        "onworkplace": 0,
        "p": [],
        "order": "2",
        "action": "RECYCLE"
      },
      "3": {
        "name": "疯狂BP",
        "onworkplace": 0,
        "p": [],
        "order": "3",
        "action": "NUTSBP"
      },
      "-1": {
        "name": "收件箱",
        "onworkplace": 0,
        "p": [
          {
            "_id": "5a4d7bd39b8d4008a777ae24",
            "_type": "p",
            "gp_moved_at": {
              "$date": {
                "$numberLong": "1515027411465"
              }
            },
            "gp_source_label": "系统发来的示例",
            "gp_source_args": [],
            "gp_prev": {
              "name": "收件箱",
              "onworkplace": 0,
              "order": "-1",
              "action": "INBOX"
            },
            "gp_prev_path": "-1",
            "gp_prev_p_index": 0
          }
        ],
        "order": "-1",
        "action": "INBOX"
      },
      "extra": [
        {
          "created_at": {
            "$date": {
              "$numberLong": "1515027411142"
            }
          },
          "order": 1,
          "name": "储备项目",
          "onworkplace": 1,
          "p": []
        }
      ]
    },
    "created_at": "2018-01-04T08:56:51.127+08:00",
    "_type": "u",
    "updated_at": "2018-01-04T08:56:52.141+08:00",
    "uuid": "c6c7ca5d-ade2-4102-a1c6-ea5b22b660f6",
    "token": "NWE0ZDdiZDM5YjhkNDAwOGE3NzdhZTIyMjAxODAxMDQwODU2NTJObUkyTkRNeVltVmtZMkZrTm0=",
    "card": null,
    ".session_id": "9650A6796C83B7BEBEBA2D6B0E6E5F7C"
  }
         */
        this.afterLogin(data)
        this.closeModal()
      } catch (e) {
        this.error = _.get(e, 'response.data.msg') || e.message
      }
    },
    async commitSignin (input) {
      let validate = await this.$validator.validateAll(input)

      if (!validate) {
        this.error = this.errors.all()[0]
        return
      }
      try {
        let res = await dcV1.post('/login', {
          phone: input.username,
          password: input.password
        })
        let data = _.get(res, 'data.data')
        this.afterLogin(data)
        this.closeModal()
      } catch (e) {
        this.error = _.get(e, 'response.data.msg') || e.message
      }
    },

    openEdit () {
      if (!this.isLogin || !this.isMyHome) {
        // this.m = 'home'
        this.goHome()
        return
      }
      this.isEditMode = !this.isEditMode
    },
    goHome () {
      window.location.href = `https://${env.baseDomain}/u/${Mem.get('me.u.account')}`
    },
    clickInbox () {
      window.open(`https://${env.baseDomain}`, '__blank')
    },
    clickAvatar () { console.log('clickAvatar') },

    async fetch () {
      try {
        let data = null
        if (window.__data) {
          data = _.get(window.__data, 'user[0]')
        } else {
          data = await this.fetchPageData()
        }
        if (!data) {
          throw new Error(`data not found (${this.pageAccount})`)
        }

        if (this.config.industry.length <= 0) {
          this.config.industry = await this.fetchIndustryConfig()
        }

        if (
          !data.user_module ||
          !Array.isArray(data.user_module) ||
          data.user_module.length <= 0
        ) {
          data.user_module = _.cloneDeep(this.defaultMdList)
          await this.createInitialModule()
        } else {
          data.user_module = this.parseModule(data.user_module)
        }

        let res = await ranch.post('/deliver/qa/sends', {
          user: _.get(data, 'uuid')
        })
        let qaCount = _.get(res, 'data.data')
        data.investor.qaCount = qaCount

        this.data = data
      } catch (e) {
        console.error(e)
      } finally {
        this.fetched = true
      }
    },
    async fetchPageData () {
      let res = await dcV2Graphql.post('/', {
        query: `query ($account: [String]) {
          user (account: $account) {
            id, uuid, province, city,
            pr_state, metadata, pv, created_at, updated_at, account,
            card { _id, name, phone, email, title, profile, head_image_url },
            phone,
            investor {
              id, sort, deliverPrice, deliverCount, deliverIncome, state
              user { id }
            },
            user_module { id, name, type, data }
          },
          userModuleTypeConfig
        }`,
        variables: {
          account: [this.pageAccount]
        }
      })
      return _.get(res, 'data.data.user[0]')
    },
    async fetchIndustryConfig () {
      try {
        let res = await conf.get('/db/industry.json')
        /**
         * from [{industry_id: 11, name: "智能硬件   ", show: 1, rank: 11}]
         * to [{label: "智能硬件", value: 11}]
         */
        return _.get(res, 'data', [])
          .filter(row => {
            if (row.show === 1) {
              return true
            }
            return false
          })
          .map(row => {
            return {
              label: _.trim(row.name),
              value: row.industry_id
            }
          })
      } catch (e) {
        return []
      }
    },

    parseModule (list) {
      let md0 = _.find(list, { type: 'preference' })
      let md1 = _.find(list, { type: 'case' })
      return [
        {
          id: md0.id,
          type: 'md-list',
          name: '投资偏好',
          value: [
            {
              type: 'tag',
              name: '投资阶段',
              ref: 'stage',
              value: _.get(md0, 'data.stage', [])
            },
            {
              type: 'tag',
              name: '投资领域',
              ref: 'industry',
              value: _.get(md0, 'data.field', [])
            },
            {
              type: 'range',
              name: '单个项目投资金额',
              unit: 10000,
              value: _.get(md0, 'data.amount', [])
            }
          ]
        },
        {
          id: md1.id,
          type: 'md-case',
          name: '投资案例',
          value: _.get(md1, 'data', []).map(row => {
            return {
              type: 'media',
              name: _.get(row, 'name'),
              value: _.get(row, 'desc'),
              label: _.get(row, 'industry'),
              img: _.get(row, 'logo.url')
            }
          })
        }
      ]
    },

    async createInitialModule () {
      let query = `mutation ($name: String, $type: String, $data: JSON, $metadata: JSON) {
        createUserModule(name: $name, type: $type, data: $data, metadata: $metadata) { id }
      }`
      let res = await Promise.all([
        await dcV2Graphql.post('', {
          query,
          variables: {
            type: 'preference',
            data: {
              amount: [0, 0], // [min, max]
              field: [], // [id, ...]
              stage: [] // ["A", "B", ...]
            }
          }
        }, {
          headers: {
            Authorization: `Token ${Store.get('token')}`
          }
        }),
        await dcV2Graphql.post('', {
          query,
          variables: {
            type: 'case',
            data: [
              {
                desc: '', // string(2048)
                industry: '', // string(32)
                name: '' // string(32)
              }
            ]
          }
        }, {
          headers: {
            Authorization: `Token ${Store.get('token')}`
          }
        })
      ])
      console.log(res)
    },

    updateUser (partial) {
      _.merge(this.data, partial)
    },
    updateMe (partial) {
      Mem.merge('me.u', partial)
    },
    updateModule (i, partial) {
      // this.data.user_module[i].value = _.merge(this.data.user_module[i].value, partial)
      this.data.user_module[i].value = partial
    }
  },
  watch: {
    isMyHome (newValue, oldValue) {
      if (!newValue) {
        this.m = 'home'
      }
    }
  },
  created () {
    this.$validator.attach({name: 'username', rules: 'required|regex:^.{11}$', alias: '手机号'})
    this.$validator.attach({name: 'password', rules: 'required|min:6|max:16', alias: '密码'})
    this.$validator.attach({name: 'code', rules: 'required|min:6|max:6', alias: '验证码'})
  },
  async mounted () {
    let u = this.$route.query.nutsbptoken
    if (u) {
      Store.set('u', u)
      delete this.$route.query.nutsbptoken
      this.$router.push({ path: '/home' })
      this.$router.push({ name: 'home', query: { ...this.$route.query } })
    }
    await this.fetch()
    await this.restore()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="postcss" scoped>
@import "index.css";
.home {
  & .home-header {
    height: calc(230px / var(--scale));
    background-image: url('http://az.img.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_page_top_bar.png');
  }
}
</style>



// WEBPACK FOOTER //
// src/page/HomePage.vue